import React, { useState } from 'react';
import { NavigationRoutes } from 'utils';

interface initialState {
  isSidebarOpen: boolean;
  currentRoute: string;
  sideList: any[];
  activeMenu: '';
  updateProgressBar: boolean;
}

interface IGlobalState {
  globalState: initialState;
  updateState: (_key: string, _value: any) => void;
}

const initialStates: initialState = {
  isSidebarOpen: true,
  currentRoute: NavigationRoutes?.dashboard,
  sideList: [],
  activeMenu: '',
  updateProgressBar: false,
};

export const GlobalStateContext = React.createContext<IGlobalState>({
  globalState: initialStates,
  updateState: (_key: string, _value: any) => {},
});

export function useGlobalStateManager() {
  const [globalState, setglobalStates] = useState<any>(initialStates);

  const updateState = (key: string, value: any) => {
    setglobalStates((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return {
    globalState,
    updateState,
  };
}

export function useGlobalState() {
  return React.useContext(GlobalStateContext);
}
